import {
  LOAD_TRANSLATIONS,
  LOAD_TRANSLATIONS_FAILURE,
  LOAD_TRANSLATIONS_SUCCESS,
} from "./translation.actions";
import { withLoadingState } from "../store/shared";

/*
  interface TranslationState {
    [localeKey: string]: TranslationList;
  }
*/

/*
  interface TranslationList {
    key: string;
    value: string;
  }
*/

const reducer = (state = {}, action) => {
  switch (action.type) {
    case LOAD_TRANSLATIONS_SUCCESS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default withLoadingState({
  loadActionType: LOAD_TRANSLATIONS,
  successActionType: LOAD_TRANSLATIONS_SUCCESS,
  failureActionType: LOAD_TRANSLATIONS_FAILURE,
})(reducer);
